<div
  class="dialog-content contact-dialog"
  fxLayout="column"
  fxLayoutAlign="space-evenly"
>
  <h1>We Are Here To Help</h1>
  <div fxLayout="row" fxLayoutAlign="space-around center" fxFlex="1 0 168px">
    <div class="contact">
      <p class="contact-name">Sam Willson</p>
      <p class="contact-title">Sales Rep</p>
      <p class="contact-email">
        <a
          mat-button
          color="accent"
          href="mailto:SWillson@republicservices.com"
        >
          SWillson@republicservices.com
        </a>
      </p>
      <p class="contact-phone"><a href="tel:+12818314062">281-831-4062</a></p>
    </div>
    <div class="contact">
      <p class="contact-name">Renee Lemond</p>
      <p class="contact-title">Sales Support Specialist</p>
      <p class="contact-email">
        <a mat-button color="accent" href="mailto:RLemond@republicservices.com">
          RLemond@republicservices.com
        </a>
      </p>
      <p class="contact-phone"><a href="tel:+17136767628">713-676-7628</a></p>
    </div>
  </div>
  <button
    mat-icon-button
    cdkFocusInitial
    class="close"
    aria-label="Close dialog"
    color="accent"
    [disableRipple]="true"
    [mat-dialog-close]=""
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
